import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationComponent } from './localization/localization.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [LocalizationComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [LocalizationComponent]
})
export class SharedModule { }
